import React from "react";
import Registration from "./Registration";

const RegistrationWithQuery = props => (
  <Registration title={"Registration"} {...props} />
);

export default RegistrationWithQuery;
